export function validatePhoneNumber(phoneNumber) {
    const regExp = /^1[3456789]\d{9}$/; // 定义手机号的正则表达式规则
    if (regExp.test(phoneNumber)) {
      return true
    } else {
      return false
    }
}